let config = {}
if (window.location.href.indexOf('https://user.kaxiubaodian.com') !== -1) {
  config = {
    hostOld: 'https://user.kaxiubaodian.com/api/',
    hostOld2: 'https://user.kaxiubaodian.com/api/',
    hostApi: 'https://user.kaxiubaodian.com/api/',
    hostCommon: 'https://user.kaxiubaodian.com/api/common/',
    hostApp: 'https://user.kaxiubaodian.com/api/app/',
    hostResourcePath: 'https://user.kaxiubaodian.com',
    newHost: 'https://user.kaxiubaodian.com/api/',
    crmHost: 'https://user.kaxiubaodian.com/api/crmService/'
  }
} else if (window.location.href.indexOf('https://kaxiubaodian-test.jieletong.com') !== -1) {
  config = {
    hostOld: 'https://kaxiubaodian-test.jieletong.com/api/',
    hostOld2: 'https://kaxiubaodian-test.jieletong.com/api/',
    hostApi: 'https://kaxiubaodian-test.jieletong.com/api/',
    hostCommon: 'https://kaxiubaodian-test.jieletong.com/api/common/',
    hostApp: 'https://kaxiubaodian-test.jieletong.com/api/app/',
    hostResourcePath: 'https://kaxiubaodian-test.jieletong.com',
    newHost: 'https://kaxiubaodian-test.jieletong.com/api/',
    crmHost: 'https://kaxiubaodian-test.jieletong.com/api/crmService/'
  }
} else {
  config = {
    hostOld: '/mockApi/',
    hostOld2: '/mockApi/',
    hostApi: '/mockApi/',
    hostCommon: '/mockApi/common/',
    hostApp: '/mockApi/app/',
    hostResourcePath: '/mockApi',
    newHost: '/mockApi/',
    crmHost: '/mockApi/crmService/'
  }
  // config = {
  //   hostOld: '/api/',
  //   hostOld2: '/api/',
  //   hostApi: '/api/',
  //   hostCommon: '/api/common/',
  //   hostApp: '/api/app/',
  //   hostResourcePath: '/api',
  //   newHost: '/api/',
  //   crmHost: '/api/crmService/'
  // }
}

export default {
  config
}
